export default __webpack_public_path__ + "static/media/tech.8f6f9b1f.jpeg";